import { PostProperties } from "../types";
import image from "../img/exposeWanderbursche.jpg";

const post: PostProperties = {
  id: 25,
  title: "Exposé 08 - Wanderbursche",
  content:
    'Wanderbursche is a techno artist who developed his passion for electronic music during his studies in Scotland. Over time, his interest solidified into a deep connection with techno, which he describes as "minimalist yet heavy", often exploring hypnotic melodies and atmospheric soundscapes. He cites DVS1 as his biggest influence, alongside Speedy J and other pioneers of the genre.',
  image,
  buttonText: "Read More",
  buttonUrl: "expose-08-wanderbursche",
  category: "Expose",
  embedCode: `<iframe width="100%" height="600" scrolling="no" frameborder="no" allow="autoplay" src="https://w.soundcloud.com/player/?url=https%3A//api.soundcloud.com/tracks/2012522251%3Fsecret_token%3Ds-FJWZNPfpPfv&color=%23ff5500&auto_play=true&hide_related=false&show_comments=true&show_user=true&show_reposts=false&show_teaser=true&visual=true"></iframe><div style="font-size: 10px; color: #cccccc;line-break: anywhere;word-break: normal;overflow: hidden;white-space: nowrap;text-overflow: ellipsis; font-family: Interstate,Lucida Grande,Lucida Sans Unicode,Lucida Sans,Garuda,Verdana,Tahoma,sans-serif;font-weight: 100;"><a href="https://soundcloud.com/shubinproject" title="Shubin" target="_blank" style="color: #cccccc; text-decoration: none;">Shubin</a> · <a href="https://soundcloud.com/shubinproject/expose-08-wanderbursche/s-FJWZNPfpPfv" title="Exposé 08 - Wanderbursche" target="_blank" style="color: #cccccc; text-decoration: none;">Exposé 08 - Wanderbursche</a></div>`,
  questionsAndAnswers: [
    {
      question:
        "As an artist, how would you describe your unique style and sound?",
      answer:
        "Accurately describing music with words is, in my opinion, impossible. However, I would define my sound as the perfect mixture of rhythms, atmospheres, and melodies that elevate the mind beyond the body and guide it on a spiritual journey.",
    },
    {
      question:
        "Which artists or producers have had the most significant impact on your music and career?",
      answer:
        "DVS1, Speedy J, Luke Slater, Adriana Lopez, Drumcell, and Stephanie Sykes.",
    },
    {
      question:
        "How do you discover new music and stay informed about emerging artists and styles?",
      answer:
        "I dig through my favorite labels, exploring the works of each artist featured in their releases. I then look into which other labels have supported those artists and dive into their other releases as well, repeating the process recursively.",
    },
    {
      question:
        "What elements of your personality and personal experiences do you incorporate into your music?",
      answer:
        "I strive to make people feel what I felt when I first heard the artists who have inspired me the most. At the same time, my sound often reflects my current mood - during my sets, the emotions I'm experiencing shape the journey on which I take the listener. (hence how I came up with my nickname - Wanderbursche. It reflects my constant exploration of new sounds, emotions, and atmospheres, as well as my desire to take listeners on a journey through my music.)",
    },
  ],
  translationsBg: {
    content: `Wanderbursche е техно артист, развил страстта си към електронната музика по времето на следването си в Шотландия. С времето интересът му се е превърнал в дълбока връзка с техното, което той описва като „минималистично, но тежко", като често изследва хипнотични мелодии и атмосферни звукови пространства. Той посочва DVS1 като свое най-голямо влияние, наред със Speedy J и другите пионери на жанра.`,
    questionsAndAnswers: [
      {
        question: "Как би описал уникалния си стил и звук като артист?",
        answer:
          "Точното описване на музиката с думи е, според мен, невъзможно. Въпреки това бих определил звука си като перфектна смесица от ритми, атмосфери и мелодии, издигащи ума над тялото и водещи го на духовно пътешествие.",
      },
      {
        question:
          "Кои артисти или продуценти са оказали най-значително влияние върху музиката и кариерата ти?",
        answer:
          "DVS1, Speedy J, Luke Slater, Adriana Lopez, Drumcell и Stephanie Sykes.",
      },
      {
        question:
          "Как откривате нова музика и следите за новите артисти и стилове?",
        answer:
          "Ровя се в любимите ми лейбъли, изследвайки творчеството на всеки артист, включен в техните издания. След това проверявам кои други лейбъли са подкрепили тези артисти и се гмуркам в другите им издания, повтаряйки процеса рекурсивно.",
      },
      {
        question:
          "Кои елементи от личността и личния си опит включваш в музиката си?",
        answer:
          "Стремя се хората да почувстват онова, което аз почувствах, когато чух за първи път артистите, вдъхновили ме най-много. В същото време звукът ми често отразява текущото ми настроение – по време на сетовете ми емоциите, които изпитвам, оформят пътешествието, на което водя слушателя. (Именно от тук идва и псевдонимът ми Wanderbursche – той отразява непрестанното ми изследване на нови звуци, емоции и атмосфери, както и желанието ми да водя слушателите на пътешествие чрез музиката си.)",
      },
    ],
  },
};

export default post;
